<template>
	<Head title="Instalação do Agente Habilite-se" />

	<div class="p-5 text-center text-danger" v-if="invalid_url">
		<h1 class="text-danger">Ocorreu um erro!</h1>
		<h3 class="text-danger">
			Não foi possível carregar as informações necessárias para a
			validação da instalação do agente.
		</h3>
		<h5 class="text-danger">Entre em contato com o suporte.</h5>
	</div>

	<div v-else>
		<div class="text-center p-5" v-if="code_validated_successfully">
			<h2 class="text-success">
				<i
					class="fa-regular fa-circle-check fa-2xl"
					style="color: #50cd89"></i>
				Código de instalação validado com sucesso !
			</h2>
			<h5 class="text-success">
				Aguarde, em alguns segundos esta página será fechada.
			</h5>
		</div>

		<div id="code-validation" v-else>
			<div class="text-center">
				<h2 class="mb-5" id="title">
					Instalação do agente de segurança
				</h2>
				<h5>
					Para continuar você precisa ter o código de instalação do
					agente.
				</h5>
			</div>

			<div class="text-center">
				<h5 class="mt-10" v-if="loading">
					<i class="fa-solid fa-spinner fa-spin fa-2xl me-3"></i>
					Validando o código
				</h5>
				<h5 class="text-center mt-10" v-else>
					Digite o código de instalação do agente abaixo
				</h5>

				<div class="d-flex justify-content-center mt-5">
					<v-otp-input
						:is-disabled="loading"
						v-model:value="code"
						input-classes="otp-input"
						separator="-"
						:num-inputs="8"
						:should-auto-focus="true"
						input-type="letter-numeric"
						@on-complete="handleOnComplete" />
				</div>

				<p
					v-if="
						code_validated_successfully !== null &&
						!code_validated_successfully
					"
					class="m-0 mt-5 fs-4 text-danger fw-bold">
					{{ error_message }}
				</p>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import Layout from '../../Layouts/simple_layout.vue';
	import { Ref, onBeforeMount, ref } from 'vue';
	import axios from 'axios';

	export default {
		layout: Layout,
	};
</script>

<script setup lang="ts">
	import { Head } from '@inertiajs/vue3';
	import VOtpInput from 'vue3-otp-input';

	const props = defineProps({
		validate_agent_installation_code_url: { type: String, required: true },
		finish_agent_installation_url: { type: String, required: true },
	});

	interface AgentInstallationInfo {
		guid: string;
		host: string;
		agent_version: string;
	}

	interface AgentInstallationComputerHost {
		os: string;
		platform: string;
	}

	const code = ref('');

	const loading = ref(false);

	const code_validated_successfully: Ref<null | boolean> = ref(null);

	let error_message = '';

	const params = new URLSearchParams(window.location.search);

	let invalid_url = false;

	const paramsObj = Array.from(params.keys()).reduce(
		(acc, val) => ({ ...acc, [val]: params.get(val) }),
		{}
	) as AgentInstallationInfo;

	function getComputerInfo() {
		const computer_host = JSON.parse(
			paramsObj.host
		) as AgentInstallationComputerHost;

		return {
			os: computer_host.os,
			platform: computer_host.platform,
			guid: paramsObj.guid,
			agent_version: paramsObj.agent_version,
		};
	}

	async function activateAgent(installation_code: string) {
		loading.value = true;

		code_validated_successfully.value = null;

		try {
			const response = await axios.post(
				props.validate_agent_installation_code_url,
				{
					installation_code: installation_code.toUpperCase(),
					guid: getComputerInfo().guid,
				}
			);

			//@ts-ignore
			//window.runAgentActivation is injected on the page by the agent
			const is_actived = window.runAgentActivation
				? await window.runAgentActivation(
						response.data.token,
						response.data.computer_uid
				  )
				: true;

			if (!is_actived) {
				throw new Error(
					'Não foi possível ativar o agente. Entre em contato com o suporte'
				);
			}

			await axios.post(props.finish_agent_installation_url, {
				...getComputerInfo(),
				computer_id: response.data.computer_id,
			});

			code_validated_successfully.value = true;
		} catch (error) {
			error_message = error.response
				? error.response.data.message
				: error;
			code_validated_successfully.value = false;
		} finally {
			loading.value = false;
		}
	}

	const handleOnComplete = (value: string) => {
		activateAgent(value);
	};

	onBeforeMount(() => {
		if (Object.keys(paramsObj).length === 0) {
			invalid_url = true;
		}
	});
</script>

<style>
	.otp-input {
		width: 40px;
		height: 40px;
		padding: 5px;
		margin: 0 10px;
		font-size: 20px;
		border-radius: 4px;
		border: 1px solid rgba(0, 0, 0, 0.3);
		text-align: center;
		text-transform: uppercase;
	}
	.otp-input.is-complete {
		background-color: #e4e4e4;
	}
	.otp-input::-webkit-inner-spin-button,
	.otp-input::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	@media (max-width: 600px) {
		.otp-input {
			width: 16px;
			height: 25px;
			font-size: 10px;
		}
	}
</style>
